export default "__VITE_ASSET__D8KS0tLB__"